import React from 'react';
import { Box } from '@mui/material';
import BuilderSidebar from './BuilderSidebar';
import BuilderToolbar from './BuilderToolbar';
import { BUILDER_DEVICE_MODES } from './builderArchitecture';
import './PromoShowcaseBuilder.css';
import './PromoShowcaseBuilderRuntime.css';

/**
 * Pure presentation shell for the PromoShowcase editor.
 *
 * Business logic intentionally stays in PromoShowcasePage during the 2026 UI
 * modernization. Existing handlers are passed into this shell rather than
 * rewritten here, keeping WordPress apply/sync behavior unchanged.
 */
export default function PromoShowcaseBuilderWorkspace({
  toolbarProps,
  sidebarProps,
  deviceMode = BUILDER_DEVICE_MODES.DESKTOP,
  children,
}) {
  return (
    <Box className="ps-builder-workspace">
      <BuilderToolbar {...toolbarProps} deviceMode={deviceMode} />
      <Box className="ps-builder-workspace__body">
        <BuilderSidebar {...sidebarProps} />
        <Box className="ps-builder-canvas--2026">
          <Box className="ps-builder-canvas__viewport" data-device={deviceMode}>
            <Box className="ps-builder-canvas__frame--2026">{children}</Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
